export const DASHBOARD_CSRF_HEADER = "x-omniroute-csrf";
